import React from "react";

import MainTemplate from "@/components/Templates/MainTemplate";
import { FlexContainer } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

import { ElementContainer, Heading, Wrap } from "./style";

function ContactUs() {
  return (
    <MainTemplate>
      <FlexContainer py={"70px"} minHeight={"65vh"}>
        <Wrap>
          <ElementContainer flexDirection={"column"} justifyContent={"center"}>
            <Heading
              variant={"heading2"}
              fontSize={["24px", "30px", "30px"]}
              color={theme.colorsV2.gray.shade_500}
              lineHeight={"normal"}
              mb="20px"
            >
              Contact Us
            </Heading>
            <Typography
              variant="paragraph2"
              mb={"15px"}
              color={theme.colors.gray_100}
            >
              For anything, please feel free to contact us!
            </Typography>
            <Typography variant="paragraph2" color={theme.colors.gray_100}>
              Email:{" "}
              <Typography
                link1Color={theme.colors.dotsColor}
                variant="link1"
                href={"mailto:help@betheshyft.com"}
                fontSize={"inherit"}
              >
                help@betheshyft.com
              </Typography>{" "}
              or
            </Typography>
            <Typography color={theme.colors.gray_100} variant="paragraph2">
              WhatsApp:{" "}
              <a
                href={`https://api.whatsapp.com/send/?phone=%2B91${process.env.NEXT_PUBLIC_CONTACT_NUMBER}&text&type=phone_number&app_absent=0`}
              >{`+91-${process.env.NEXT_PUBLIC_CONTACT_NUMBER}`}</a>
            </Typography>
          </ElementContainer>
          {/* <ElementContainer alignItems={"center"}>
            <Typography color={theme.colors.gray_100} variant="paragraph2">
              Our studio locations are currently closed due to Covid-19. We will
              update here once there is a change to it
            </Typography>
          </ElementContainer> */}
        </Wrap>
      </FlexContainer>
    </MainTemplate>
  );
}

export default ContactUs;
